const e = "styles-module__no_image___-RiGo", o = {
  no_image: e
};
export {
  o as default,
  e as no_image
};
